var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"scatter","height":"400","options":_vm.apexChatData.scatterChart.chartOptions,"series":_vm.apexChatData.scatterChart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }